import useT from '@hooks/useTranslation'

import styles from 'styles/search/AdListEmpty.module.css'

export default function AdListEmpty () {
    return <p className={styles.info}>
        {useT('Nie odnaleziono ogłoszeń o podanych kryteriach. Inne ogłoszenia, które mogą Ci się spodobać')}:
    </p>
}